module.exports = __webpack_public_path__ + "media/images/icons/twotone/clock-circle-8fd8ec28834300b75789ba57b3274b63.svg";